import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { checkAuth, initializeUserSession } from 'src/redux/thunks/authThunks';
import { isTenantDomain } from 'src/utils/domainContext';

export default function AuthGuard({ children }) {
  const dispatch = useDispatch();
  const { isAuthenticated, isInitialized, isSessionLoaded, sites } = useSelector((state) => state.auth);
  const location = useLocation();

  // Trigger auth check only if not initialized
  useEffect(() => {
    if (!isInitialized) {
      dispatch(checkAuth());
      dispatch(initializeUserSession());
    }
  }, [dispatch, isInitialized]);

  if (!isInitialized) {
    return null; // or a <SplashScreen />
  }

  // Wait for initializeUserSession to finish before making any access decision
  if (!isSessionLoaded) {
    return null; // still loading session data
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/jwt/login" state={{ from: location }} replace />;
  }

  // Cross-tenant protection: if session loaded but no sites,
  // the user doesn't belong to this tenant — send to login
  if (isTenantDomain()) {
    if (!sites || sites.length === 0) {
      return <Navigate to="/auth/jwt/login" replace />;
    }
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};